// @@ LSSB API LIbrary
export async function clearUserData() {
  return sessionStorage.removeItem("lssbAdminData");
}

export function setUserData(data) {
  data = JSON.stringify(data);
  return sessionStorage.setItem("lssbAdminData", data);
}

// @@ LSSB API LIbrary

export const LSSB = {};

const LSSBConfig = {
  MEDIA_UPLOADS_URL: "https://static.lagosscholarship.org/upload",
  ENDPOINT_URL: `https://api2.lagosscholarship.org/endpoint`,
  BATCH_URL: `https://api2.lagosscholarship.org/batch`,
  PAY_ENDPOINT_URL: `https://pay.lagosscholarship.org/_payex_/`,
  LASRRA_ENDPOINT_URL: `https://lasrra.lagosscholarship.org/get_lasrra_data`,
  mode: "dev",
};

const XX = {
  fn: {},
  state: {
    vState: {},
  },
};

 XX.fn.log = LSSBConfig.mode == "dev" ? console.log : function () {};

XX.jx = (options) => {
  // numt++;

  const promise = new Promise((resolve, reject) => {
    let url, method, data;
    const xhr = new XMLHttpRequest();

    xhr.withCredentials = false;

    if (!options && !options.url) {
      // XX.fn.log("Please provide a url");
      reject("No url provided!");

      return;
    }

    url = options.url;
    data = options.data ? options.data : {};
    data =
      options.contentType == "multipart/form-data"
        ? data
        : JSON.stringify(data);

    method = options.method || "GET";

    let actCont = "a/j";
    if (options.contentType !== "application/json") {
      actCont = "m/f";
    }

    let reqType = options && options.reqType ? options.reqType : null;
    let resType = options && options.resType ? options.resType : "json";

    xhr.open("POST", url);

    xhr.responseType = resType;

    xhr.onload = function () {
      resolve(xhr.response);
      // XX.fn.log(xhr.response );
    };

    xhr.onerror = function (err) {
      reject(err);
      XX.fn.log(err, "url");
    };

    // for CORS
    let act = "";
    // XX.fn.log(options.auth.replace('@', '&&&'));
    let aaa = options.auth ? options.auth.replace("@", "&&&") : "";

    if (options.cors) {
      let uri = "app:///com/xapp/rn/LSSB.rn/LSSB.rx/k";
      let isApp = uri.indexOf("app:///") > -1;

      uri = isApp
        ? uri.split(":///")[1].split("/")[3] +
          "/" +
          uri.split(":///")[1].split("/")[4]
        : uri.split("://")[1].split("/")[0];

      // XX.fn.log('RHEF:', uri );
      uri = uri.indexOf(":") > -1 ? uri.split(":").join("__") : uri;

      uri = uri.split("?")[0]; //@@ to popoff ?params path in JX reqs

      let u = "--l$#F!" + uri + "/" + "$/;$#";
      let ct = "*/*~~" + "H61~%%" + actCont + "%&7&",
        au = "--u^&#" + aaa + "%&0&",
        m = "00_l%%" + method + "=+8%$jhfAQr61";
      act = ct + u + au + m;
    }

    xhr.setRequestHeader("Accept", act);
    xhr.send(data);
  });

  // XX.fn.log('Ajax ran:', numt);

  return promise;
};

// -- @@ Fetch/Send Data
XX.hitEn = function (endOptions) {
  if (!endOptions || !endOptions.route) {
    return;
  }
  let rid = endOptions.rid ? "/" + endOptions.rid : "";
  // let method_ = endOptions._method || 'GET';
  // let params_ = endOptions.rid ? '' : '?limit=10';
  let params_ = endOptions.params || "";

  if (!endOptions.state) {
    endOptions.state = {};
  }

  // XX.fn.log(' endOptions ----- ==>', endOptions);

  let isPayment = endOptions.data.isPayment;
  let isLASRRA = endOptions.data.isLASRRA;
  let FINAL_URL = `${LSSBConfig.ENDPOINT_URL}/${endOptions.route}${rid}${params_}`;

  FINAL_URL =
    endOptions.route.indexOf("batch_uploads") > -1
      ? `${LSSBConfig.BATCH_URL}/batch_upload`
      : FINAL_URL;
  
      FINAL_URL =
      endOptions.route.indexOf("file_uploads") > -1
        ? `${LSSBConfig.MEDIA_UPLOADS_URL}`
        : FINAL_URL;    

 

  const options = {
    url: isPayment || isLASRRA ? ( isLASRRA ? `${LSSBConfig.LASRRA_ENDPOINT_URL}` : `${LSSBConfig.PAY_ENDPOINT_URL}`) : FINAL_URL,
    method: isPayment || isLASRRA ? 'POST' : (endOptions._method || 'GET'),
    contentType: endOptions.contentType || "application/json",
    // auth: aky,
    data: endOptions.data || {},
    cors: true,
    // data: fieldData endOptions.state.ready
  };

  if (options.url.indexOf("MEDIA_UPLOADS_URL") > -1) {
    options.url = LSSBConfig.MEDIA_UPLOADS_URL;
  }

  // @@ handle queries and Auths
  if (endOptions.$query) {
    if (options.data instanceof FormData) {
      options.data.append("$query", JSON.stringify(endOptions.$query));
      options.data.append("parse_query", "true");
    } else {
      options.data.$query = endOptions.$query;
    }

    // XX.fn.log('query man -->', options.data instanceof FormData);
  }

  if (endOptions.$k) {
    if (options.data instanceof FormData) {
      options.data.append("$k", endOptions.$k);
    } else {
      options.data.$k = endOptions.$k;
    }
  }

  let _st = endOptions.state;
  XX.jx(options)
    .then((res) => {
      if (endOptions.logResponse) {
        XX.fn.log("LSSB API Response ====>", res);
      }

      // XX.fn.log('LSSB API Response ====>', res);

      // Network or server error
      if (!res || res.error) {
        if (typeof endOptions.errorFnc == "function") {
          endOptions.errorFnc(res);
        }
      }

      // @@ success with other messages like updated etc or a msg
      else if (res.success && typeof res.data == "object") {
        if (typeof endOptions.successFnc == "function") {
          endOptions.successFnc(res);
        }

        // @@ success with other messages like updated etc or a msg
      }
      // some form of failure
      else if (typeof res.success == "boolean" && !res.success) {
        if (typeof endOptions.errorFnc == "function") {
          endOptions.errorFnc(res);
        }
      }
    })
    .catch((err) => {
      // XX.fn.log("err after JX repsonse ==>", err);

      if (typeof endOptions.errorFnc == "function") {
        endOptions.errorFnc({ error: { msg: "Server unreacheable" } });
      }
    });
};

/**
 * @@ -- API endpoint Map
 * * key:vals
 */

XX.api_endpoint_map = {
  file_uploads: "file_uploads",
  batch_uploads: "batch_uploads",

  auth_admin: "LSSB_admin",
  fetch_admins: "LSSB_admin",
  create_admin: "LSSB_admin",
  update_admin: "LSSB_admin",
  create_super_admin: "LSSB_admin",
  fetch_report: "LSSB_admin",

  reset_admin_password: "LSSB_admin",
  initiate_admin_reset_password: "LSSB_admin",

  use_pin: "LSSB_PINs",
  fetch_pins: "LSSB_PINs",
  create_pin: "LSSB_PINs",
  delete_pin: "LSSB_PINs",

  create_user: "LSSB_users",
  auth_user: "LSSB_users",
  update_user: "LSSB_users",
  fetch_users: "LSSB_users",

  reset_password: "LSSB_users",
  initiate_reset_password: "LSSB_users",

  initiate_payment: "LSSB_users",
  check_payment_status: "LSSB_users",

  create_application: "LSSB_applications",
  fetch_applications: "LSSB_applications", // @@ only admin
  // fetch_user_applications: 'LSSB_applications', // @@ called by user gets applications by that user
  update_application: "LSSB_applications",

  nullify_application: "LSSB_applications",

  create_grant: "LSSB_grants",
  fetch_grant: "LSSB_grants",
  fetch_grants: "LSSB_grants",
  update_grant: "LSSB_grants",
  delete_grant: "LSSB_grants",


  get_lasrra_data: 'LSSB_lasrra',

  get_payerid: 'LSSB_payments',
  get_pay_ref: 'LSSB_payments',
  check_pay_status: 'LSSB_payments',


};

/**
 * make_API_call
 * @@ -- Params
 * * optionsObj - type object -
 * * optionsObj must include cloud_action
 */
LSSB.make_API_call = async function (optionsObj) {
  // let endPointData = { auth_user_email: email, auth_password: password, cloud_action: 'auth_user', $return_profile: true };

  // XX.fn.log(' Create Admin ..... --- >>> <<<>>>>', optionsObj);

  // return
  let { _endpoint } = optionsObj;

  delete optionsObj._endpoint;

  let endPointD =
    optionsObj.data instanceof FormData ? optionsObj.data : { ...optionsObj };
  endPointD.cloud_action = _endpoint;

  // XX.fn.log(" make_API_call ..... --- >>> <<<>>>>", endPointD);

  // return
  return new Promise((resolve, reject) => {
    // let startTime = Date.now();

    XX.hitEn({
      _method: "POST_S",
      route: XX.api_endpoint_map[_endpoint],
      contentType: optionsObj.contentType || "application/json",
      data: endPointD,
      state: XX.state.vState,

      successFnc: function (res) {
        // XX.fn.log(' LSSB Create Admin Res --> ', res, 'in', (Date.now() - startTime) / 1000);

        resolve(res);
      },

      errorFnc: function (error) {
        // XX.fn.log(' LSSB Create Admin Err --> ', error, 'in', (Date.now() - startTime) / 1000);

        resolve(error);
      },
    });
  });
};
